import { add } from 'date-fns';
import { Language } from '../translations'

export const expertViewTranslations: Record<string, Record<Language, string>> = {
  profileAlmost: {en: "Your profile is almost ready.", fi: "Profiilisi on melkein valmis."},
  missingFields: { en: "Please fill in the following missing fields:", fi: "Täytä vielä seuraavat puuttuvat kentät:"},
  title: {en: "Title", fi: "Tehtävänimike"},
  insertPhoneNumberHere: { en: "Insert phone number here", fi: "Lisää puhelinnumero tähän" },
  previewCV: { en: "Preview CV", fi: "Esikatsele CV" },
  generateNewIntroduction: { en: "Generate new introduction", fi: "Luo uusi esittely" },
  writeIntroduction: { en: "Write your personal introduction text here", fi: "Kirjoita henkilökohtainen esittelytekstisi tähän" },
  initialAIUpload: { en: "Do you want to do initial AI assisted upload of CV?", fi: "Haluatko tehdä alustavan tekoälyavusteisen CV:n latauksen?" },
  uploadCv: { en: "Upload CV", fi: "Lataa CV järjestelmään" },
  noThankYou: { en: "No thank you", fi: "Ei kiitos" },
  introductionGenerated: { en: "Introduction generated succesfully", fi: "Esittely generoitu onnistuneesti"},
  confirmCvUpload: { en: "Confirm CV Upload", fi: "Vahvista CV:n lataus" },
  cvUploadWarning: { en: "This will replace your current CV information. Are you sure?", fi: "Tämä korvaa nykyisen CV:n tiedot. Oletko varma?" },
  confirm: { en: "Confirm", fi: "Vahvista" },
  noTitle: { en: "No job title", fi: "Ei tehtävänimikettä" },
  noIntroduction: { en: "No introduction", fi: "Ei esittelyä" },
  userNotFound: { en: "User not found", fi: "Käyttäjää ei löytynyt" },
  photoUpdated: { en: "Profile photo updated successfully", fi: "Profiilikuva päivitetty onnistuneesti" },
  selectTitle: { en: "Select a title", fi: "Valitse tehtävänimike" },
  otherRoles: { en: "Other responsibilities or roles", fi: "Muut vastuut tai roolit" },
  addOtherRoles: { en: "Add other responsibilities or roles", fi: "Lisää muita vastuita tai rooleja" },
  otherRolesSaved: { en: "Other roles saved successfully", fi: "Muut roolit tallennettu onnistuneesti" },
};